import { render, staticRenderFns } from "./exTransfer.vue?vue&type=template&id=753b2e0a&scoped=true&"
import script from "./exTransfer.vue?vue&type=script&lang=js&"
export * from "./exTransfer.vue?vue&type=script&lang=js&"
import style0 from "./exTransfer.vue?vue&type=style&index=0&id=753b2e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b2e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753b2e0a')) {
      api.createRecord('753b2e0a', component.options)
    } else {
      api.reload('753b2e0a', component.options)
    }
    module.hot.accept("./exTransfer.vue?vue&type=template&id=753b2e0a&scoped=true&", function () {
      api.rerender('753b2e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/exTransfer.vue"
export default component.exports